const navElement = document.querySelector('.navigation-btf-desktop--main');

document.addEventListener('scroll', () => {
    navElement?.classList.toggle(
        'navigation-btf-desktop--main--full-width',
        window.scrollY > 0
    );
});
